<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-12-20 20:10:38
 * @LastEditTime: 2022-07-26 21:31:09
 * @LastEditors: chenguobiao
-->
<template>
  <div class="personal-order page-normal">
    <common-header selected="user" />
    <div class="page-normal__content">
      <div class="personal-order__box">
        <div class="order--list">
          <template v-if="orderList && orderList.length > 0">
            <div
              class="order__item"
              v-for="(order, idx) in orderList"
              :key="order.uid"
            >
              <div class="row">
                <div class="col">
                  <div class="label">类型</div>
                  <div class="value">
                    {{ checkTypeMapping(order.checkType) }}
                  </div>
                </div>
                <div class="col">
                  <div class="label">考级时间</div>
                  <div class="value">
                    {{ formatCreateTime(order.qualificationStartDate) }} -
                    {{ formatCreateTime(order.qualificationEndDate) }}
                  </div>
                </div>
                <div class="col">
                  <div class="label">状态</div>
                  <div class="value" :class="{ red: order.productState == 1 }">
                    {{
                      order.orderState === 1
                        ? productStateMapping(order.productState)
                        : '已关闭'
                    }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="label">活动介绍</div>
                  <div class="value">{{ order.productDescription }}</div>
                </div>
              </div>
              <div class="angle--info">
                <div class="col">
                  <p class="level">{{ order.productLevelName }}级</p>
                </div>
                <div class="col">
                  <p>{{ order.orderNum }}</p>
                  <p>{{ formatCreateTime(order.createTime) }}</p>
                </div>
              </div>
              <div class="options">
                <template
                  v-if="
                    [1, 2].includes(order.productState) && order.orderState == 1
                  "
                >
                  <div
                    class="option--button payment"
                    @click="againPayment(idx)"
                  >
                    重新支付
                  </div>
                  <div
                    class="option--button cancel"
                    @click="handleClickTooltip('cancelApply', idx)"
                  >
                    取消申请
                  </div>
                </template>
                <div class="icon-service" @click="handleContact">
                  <img src="@/render/assets/images/personal/icon_service.png" />
                </div>
              </div>
              <el-tooltip
                v-model="order.show"
                placement="bottom-start"
                enterable
                manual
                :visible-arrow="false"
                popper-class="order--more--options"
              >
                <div slot="content">
                  <div class="options">
                    <div
                      @click="handleClickTooltip('quit', idx)"
                      v-if="order.quitQualifications"
                    >
                      申请退赛
                    </div>
                    <div
                      @click="handleClickTooltip('appeal', idx)"
                      v-if="
                        order.appealQualifications && 2 - order.appealNum > 0
                      "
                    >
                      申请重考
                    </div>
                    <div
                      @click="handleClickTooltip('cancelQuit', idx)"
                      v-if="order.cancelQuitQualifications"
                    >
                      取消退赛
                    </div>
                    <div
                      @click="handleClickTooltip('cancelAppeal', idx)"
                      v-if="order.cancelAppealQualifications"
                    >
                      取消申诉
                    </div>
                    <div
                      v-if="
                        !order.quitQualifications &&
                          !order.appealQualifications &&
                          !order.cancelQuitQualifications &&
                          !order.cancelAppealQualifications
                      "
                    >
                      无操作
                    </div>
                    <!-- <div @click="applyQuit">申请退赛</div>
                    <div @click="applyAppeal">申请重考</div> -->
                  </div>
                </div>
                <div class="more--icon" @click="handleShow(idx)">
                  <img src="@/render/assets/images/personal/more.png" />
                </div>
              </el-tooltip>
            </div>
          </template>
          <template v-else>
            <div class="order--list__nodata">
              <img src="@/render/assets/images/home/nodata.png" />
              <div class="order--list__nodata__text">暂无订单数据</div>
            </div>
          </template>
        </div>
        <common-back />
      </div>
    </div>
    <!-- <service-dialog /> -->
    <confirm-dialog
      :visible="confirmDialogConfig.visible"
      :desc="confirmDialogConfig.desc"
      @cancel="handleCancel"
      @confirm="handleConfirm"
    />
    <contact-service-dialog
      :visible="contactServiceDialogConfig.visible"
      :desc="contactServiceDialogConfig.desc"
      @close="handleClose"
    />
  </div>
</template>

<script>
import { dateFormat } from '@/render/utils'
import { personalAPI } from '@/apis'
import CommonHeader from '@/render/components/common/header'
import CommonBack from '@/render/components/common/back'
import { ContactServiceDialog, ConfirmDialog } from '@/render/components/dialog'
export default {
  name: 'PersonalOrder',
  data() {
    return {
      orderList: [],
      operateIdx: -1,
      operateType: '',
      confirmDialogConfig: {
        visible: false,
        desc: '',
      },
      contactServiceDialogConfig: {
        visible: false,
        desc: '',
      },
    }
  },
  components: {
    CommonHeader,
    CommonBack,
    ContactServiceDialog,
    ConfirmDialog,
  },
  mounted() {
    this.getMyOrderInfo()
  },
  methods: {
    againPayment(idx) {
      const order = this.orderList[idx]
      this.$router.push(
        '/personal-payment?orderNum=' + order.orderNum + '&back=1',
      )
    },
    async cancelApply(idx) {
      const order = this.orderList[idx]
      await personalAPI.postCancelMyOrder({
        uid: order.uid,
      })
      location.reload()
    },
    handleCancel() {
      this.confirmDialogConfig = {
        visible: false,
        desc: '',
      }
    },
    async handleConfirm() {
      const order = this.orderList[this.operateIdx]
      const apiKey = {
        quit: 'postApplyQuit',
        appeal: 'postApplyAppeal',
        cancelQuit: 'postCancelQuit',
        cancelAppeal: 'postCancelAppeal',
        cancelApply: 'postCancelMyOrder',
      }[this.operateType]
      await personalAPI[apiKey]({
        uid: order.uid,
      })
      this.handleCancel()
      if (['appeal', 'quit'].includes(this.operateType)) {
        const descMap = {
          appeal:
            '您已成功申请重考，请耐心等待五个工作日内的申诉结果，结果会以短信形式发送到你的手机上。',
          quit: '请联系客服以继续进行申请退赛操作！',
        }
        this.contactServiceDialogConfig = {
          visible: true,
          desc: descMap[this.operateType],
        }
      }
      this.getMyOrderInfo()
    },
    handleClose() {
      this.contactServiceDialogConfig = {
        visible: false,
        desc: '',
      }
    },
    handleContact() {
      this.contactServiceDialogConfig.visible = true
    },
    async handleShow(idx) {
      const order = this.orderList[idx]
      if (!order.show) {
        const { data } = await personalAPI.postCheckApplyQuitAppealPermission({
          uid: order.uid,
        })
        Object.assign(order, {
          ...data,
        })
      }
      order.show = !order.show
      this.orderList.splice(idx, 1, order)
    },
    formatCreateTime(createTime) {
      return dateFormat(
        'YYYY.mm.dd HH:MM:SS',
        new Date(createTime.replace(/-/g, '/')),
      )
    },
    calcQualificationDate(start, end) {
      const startDate = new Date(start)
      const endDate = new Date(end)
      return `${dateFormat('YYYY.mm.dd', startDate)} ${dateFormat(
        'HH:MM:SS',
        startDate,
      )}-${dateFormat('HH:MM:SS', endDate)}`
    },
    checkTypeMapping(checkType) {
      return {
        1: '自动审批',
        2: '人工审批',
      }[checkType]
    },
    productStateMapping(productState) {
      return {
        1: '未支付',
        2: '支付失败',
        3: '支付成功',
        4: '待审批',
        5: '审批完成',
        6: '审批未通过',
        7: '考试中',
        8: '考试失败',
        9: '缺考',
        10: '退赛中',
        11: '退赛',
        12: '退款成功',
        13: '申诉中',
        14: '考试成功',
      }[productState]
    },
    operateTypeMapping(type) {
      return {
        quit: '申请退赛',
        appeal: '申请重考',
        cancelQuit: '取消退赛',
        cancelAppeal: '取消重考',
        cancelApply: '取消申请',
      }[type]
    },
    async getMyOrderInfo() {
      const result = await personalAPI.postGetMyOrderInfo({
        page: 1,
        limit: 1000,
        field: 'create_time',
      })
      this.orderList = result.data.map(ele => {
        Object.assign(ele, {
          show: false,
          quitQualifications: false,
          appealQualifications: false,
          cancelQuitQualifications: false,
          cancelAppealQualifications: false,
        })
        return ele
      })
    },
    handleClickTooltip(type, idx) {
      const order = this.orderList[idx]
      const desc = `是否确认进行${this.operateTypeMapping(type)}操作${
        type == 'appeal'
          ? '，你还有' + (2 - order.appealNum) + '次重考机会！'
          : ''
      }`
      Object.assign(order, {
        show: false,
      })
      this.orderList.splice(idx, 1, order)
      this.operateIdx = idx
      this.operateType = type
      this.confirmDialogConfig = {
        visible: true,
        desc,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.page-normal__content {
}
.personal-order {
  &__box {
    position: relative;
    width: val(1230);
    margin: 0 auto;
    ::v-deep .back {
      top: val(49);
    }
  }
  .order {
    &--list {
      padding-top: val(49);
      height: calc(100vh - 1.25rem);
      overflow: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      &__nodata {
        position: absolute;
        width: val(286);
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        &__text {
          margin: val(30) auto 0;
          text-align: center;
          font-size: val(20);
          font-weight: 400;
          color: #727272;
        }
      }
    }
    &__item {
      position: relative;
      margin-bottom: val(39);
      width: val(1180);
      height: val(340);
      padding: val(82) 0 val(26) val(42);
      box-sizing: border-box;
      background: url(../../../assets/images/personal/order_bg.png) left top
        no-repeat;
      background-size: 100%;
      .row {
        display: flex;
        align-items: center;
        margin-bottom: val(8);
        .col {
          .label {
            margin-bottom: val(5);
            line-height: val(21);
            font-size: val(16);
            color: rgba(#fff, 0.5);
          }
          .value {
            height: val(24);
            font-size: val(18);
            color: #ffffff;
            &.red {
              color: #ff5858;
            }
          }
        }
        &:first-of-type .col {
          &:first-of-type {
            width: val(128);
          }
          &:nth-of-type(2) {
            width: val(464);
          }
          &:last-of-type {
            flex: 1;
          }
        }
        &:nth-of-type(2) .col {
          width: val(630);
          .value {
            display: -webkit-box;
            overflow: hidden;
            white-space: normal !important;
            text-overflow: ellipsis;
            word-wrap: break-word;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            height: val(78);
            line-height: val(26);
          }
        }
      }
      .angle--info {
        position: absolute;
        width: val(412);
        height: val(84);
        background: linear-gradient(131deg, #f1e2d8 0%, #cca790 100%);
        border-radius: val(10);
        left: val(-20);
        top: val(-20);
        padding: val(20) 0 0 val(20);
        box-sizing: border-box;
        display: flex;
        .level {
          line-height: val(56);
          font-size: val(42);
          color: #824b3b;
          margin-top: val(-6);
          margin-right: val(21);
        }
        .col:last-of-type p {
          &:first-of-type {
            margin-bottom: val(4);
            line-height: val(24);
            font-size: val(18);
            color: #824b3b;
          }
          &:last-of-type {
            line-height: val(21);
            font-size: val(16);
            color: rgba(#824b3b, 0.5);
          }
        }
      }
      .options {
        margin-top: val(29);
        display: flex;
        .option--button {
          cursor: pointer;
          margin-right: val(20);
          line-height: val(57);
          height: val(57);
          width: val(136);
          border-radius: val(29);
          font-size: val(24);
          color: #ffffff;
          box-sizing: border-box;
          text-align: center;
          &.payment {
            color: #ffeed1;
            background: linear-gradient(360deg, #b36214 0%, #fbac5d 100%);
          }
          &.cancel {
            color: #fff;
            border: val(2) solid #ffffff;
          }
        }
        .icon-service {
          cursor: pointer;
          width: val(57);
          height: val(57);
          border-radius: val(29);
          border: val(2) solid #ffffff;
          box-shadow: 0 val(3) val(6) rgba(0, 0, 0, 0.16);
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: val(30);
          }
        }
      }
      .more--icon {
        cursor: pointer;
        position: absolute;
        top: val(16);
        right: val(20);
        width: val(30);
        height: val(24);
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: val(30);
        }
      }
    }
  }
  .back--home {
    cursor: pointer;
    position: absolute;
    display: flex;
    align-items: center;
    top: val(41);
    right: val(236);
    font-size: val(18);
    color: #0077e8;
    img {
      width: val(16);
      margin-right: val(6);
    }
  }
}
</style>
<style lang="scss">
.order--more--options.el-tooltip__popper {
  padding: val(27) 0 0;
  width: val(130);
  height: val(110);
  background: url(../../../assets/images/personal/masker.png) no-repeat left top;
  background-size: 100%;
  box-sizing: border-box;
  margin-left: val(-19);
  margin-top: val(-8);
  .options div {
    cursor: pointer;
    text-align: center;
    line-height: val(18);
    font-size: val(18);
    color: #ff9100;
    margin-bottom: val(14);
    &:last-of-type {
      margin: 0;
    }
  }
}
</style>
